import { api } from '@/lib/api';

export interface ServiceClient {
  clientId: string;
  name: string;
  description: string;
  keyHint: string;
  capabilities: string[];
  createdAt: string;
  revokedAt: string | null;
  revocationReason: string | null;
}

export interface Issued {
  client: ServiceClient;
  /** Present in this one response and never again. */
  key: string;
}

export const credentials = {
  all: () => api.get<ServiceClient[]>('/api/service-clients'),
  capabilities: () => api.get<string[]>('/api/service-clients/capabilities'),
  issue: (name: string, description: string, capabilities: string[]) =>
    api.post<Issued>('/api/service-clients', { name, description, capabilities }),
  revoke: (clientId: string, reason: string) =>
    api.post<ServiceClient>(`/api/service-clients/${clientId}/revoke`, { reason }),
};
